import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Lp06::FloatingCta::Component の Stimulus コントローラ。
// landIeul: スクロール量に応じて複数区間で fadeIn/fadeOut し、fadeIn 中だけ CTA リンクを描画する。
// しきい値は isSp (max-width:767) で切替。挿入 DOM は Link(a) > areaCtaBtn#lpFloatingCta > areaCtaLink。
const CTA_ACTION_LINK = "/plan-request/";
const FADE_IN = "Lp06_fadeIn";

class SiteLp06FloatingCtaController extends Controller {
  static targets = ["contents"];

  declare readonly contentsTarget: HTMLElement;

  private link: HTMLAnchorElement | null = null;
  private handler = () => this.onScroll();

  connect(): void {
    window.addEventListener("scroll", this.handler);
    this.onScroll();
  }

  disconnect(): void {
    window.removeEventListener("scroll", this.handler);
  }

  private onScroll(): void {
    const isSp = window.matchMedia("(max-width: 767px)").matches;
    const t1 = isSp ? 860 : 700;
    const t1off = isSp ? 2730 : 3000;
    const t2 = 4000;
    const t2off = 5000;
    const t3 = isSp ? 5600 : 6000;
    const t3off = isSp ? 6500 : 6700;
    const t4 = isSp ? 7000 : 8000;
    const y = window.pageYOffset;

    let fadeIn: boolean;
    if (y > t1 && y < t1off) fadeIn = true;
    else if (y > t1off && y < t2) fadeIn = false;
    else if (y > t2 && y < t2off) fadeIn = true;
    else if (y > t2off && y < t3) fadeIn = false;
    else if (y > t3 && y < t3off) fadeIn = true;
    else if (y > t3off && y < t4) fadeIn = false;
    else if (y > t2) fadeIn = true;
    else fadeIn = false;

    this.element.classList.toggle(FADE_IN, fadeIn);
    this.toggleLink(fadeIn);
  }

  private toggleLink(show: boolean): void {
    if (show && !this.link) {
      const search = window.location.search;
      const href = search
        ? `${CTA_ACTION_LINK}${search}&utm_campaign=LP_floating`
        : `${CTA_ACTION_LINK}?utm_campaign=LP_floating`;
      const outer = document.createElement("a");
      outer.href = href;
      const btn = document.createElement("div");
      btn.className = "Lp06_areaCtaBtn";
      btn.id = "lpFloatingCta";
      const inner = document.createElement("a");
      inner.className = "Lp06_areaCtaLink";
      inner.target = "_blank";
      inner.rel = "nofollow";
      btn.appendChild(inner);
      outer.appendChild(btn);
      this.contentsTarget.appendChild(outer);
      this.link = outer;
    } else if (!show && this.link) {
      this.link.remove();
      this.link = null;
    }
  }
}

application.register("site--lp06--floating-cta", SiteLp06FloatingCtaController);
